import api from '../../utils/services/api';

import {
  balancesActionError,
  balancesActionLoading,
  balancesActionSuccess,
} from '../ducks/balances';

export const balancesFetchAction = (CPFCNPJ) => {
  return async (dispatch) => {
    dispatch(balancesActionLoading());
    try {
      const response = await api.get(
        `banco-parceiro/get/saldo?CPFCNPJ_USUARIO=${CPFCNPJ}`,
      );
      dispatch(balancesActionSuccess(response.data));
    } catch (error) {
      dispatch(balancesActionError());
    }
  };
};
